import React from 'react';
import Icon from '../../../components/AppIcon';

const SpendingInsights = ({ insights }) => {
  return (
    <div className="card h-full">
      <div className="card-header">
        <div>
          <h2 className="card-title">Spending Insights</h2>
          <p className="card-description">Personalized recommendations</p>
        </div>
      </div>

      <div className="card-content">
        <div className="space-y-3">
          {insights?.map((insight) => (
            <div 
              key={insight?.id}
              className="p-4 bg-muted/30 hover:bg-muted/50 rounded-lg transition-smooth cursor-pointer group"
            >
              <div className="flex items-start gap-3">
                <div 
                  className="w-10 h-10 rounded-full flex items-center justify-center flex-shrink-0"
                  style={{ backgroundColor: `${insight?.color}20` }}
                >
                  <Icon name={insight?.icon} size={20} style={{ color: insight?.color }} />
                </div>
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-semibold text-foreground mb-1">{insight?.title}</p>
                  <p className="text-xs text-muted-foreground mb-3">{insight?.description}</p>
                  <button 
                    className="text-xs font-medium hover:underline transition-smooth"
                    style={{ color: insight?.color }}
                  >
                    {insight?.action} →
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-6 pt-6 border-t border-border">
          <button className="w-full px-4 py-2.5 bg-primary/10 hover:bg-primary/20 text-primary rounded-lg text-sm font-medium transition-smooth flex items-center justify-center gap-2">
            <Icon name="Sparkles" size={16} />
            Get More Insights
          </button>
        </div>
      </div>
    </div>
  );
};

export default SpendingInsights;